import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Inventory Module Service Stores
 */
export const inventoryStores: ServiceStoreConfig[] = [
  {
    name: "inventory",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "inventoryId",
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.inventoryStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalItems = entities.length;
          const lowStockItems = entities.filter(
            (item: Record<string, unknown>) => {
              const qty = (item.quantity as number) || 0;
              const min = (item.minQuantity as number) || 0;
              return qty <= min && min > 0;
            }
          ).length;
          const outOfStockItems = entities.filter(
            (item: Record<string, unknown>) =>
              (item.quantity as number) === 0 || item.outOfStock
          ).length;
          const totalValue = entities.reduce(
            (sum: number, item: Record<string, unknown>) => {
              const qty = (item.quantity as number) || 0;
              const price = (item.unitPrice as number) || 0;
              return sum + qty * price;
            },
            0
          );

          return [
            {
              title: "Total Items",
              value: () => totalItems.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Low Stock",
              value: () => lowStockItems.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Out of Stock",
              value: () => outOfStockItems.toString(),
              valueColor: "error.main",
            },
            {
              title: "Total Value",
              value: () => `$${((totalValue as number) / 1000).toFixed(0)}K`,
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
        defaultSort: {
          sortBy: ["name"],
          sortDirection: { name: "ASC" },
        },
      },
    },
  },
];
